import {
    liquidGlassPressTransition,
    liquidGlassSurfaceFillSx,
    LIQUID_GLASS_PRESS_SCALE,
} from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { type FC, type ReactNode } from 'react';
import { RitualConfig } from '../../helpers/ritual';

interface RitualCardAnimationProps {
    children: ReactNode;
    config: RitualConfig;
    isCompleting: boolean;
    pressed: boolean;
}

export const RitualCardAnimation: FC<RitualCardAnimationProps> = ({
    children,
    config,
    isCompleting,
    pressed,
}) => {
    return (
        <Box
            component={motion.div}
            initial={{ opacity: 1 }}
            exit={{
                opacity: 0,
                height: 0,
                scale: 0.95,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                borderWidth: 0,
            }}
            animate={{
                scale: isCompleting ? 1.02 : pressed ? LIQUID_GLASS_PRESS_SCALE : 1,
                ...(isCompleting
                    ? {
                        backgroundColor: config.completedBg,
                        borderColor: config.completedBg,
                        borderWidth: 2,
                    }
                    : {}),
            }}
            transition={{
                opacity: { duration: 0.3 },
                height: { duration: 0.3, ease: 'easeInOut' },
                scale: liquidGlassPressTransition,
                backgroundColor: { duration: 0.3, ease: 'easeInOut' },
                marginTop: { duration: 0.3, ease: 'easeInOut' },
                marginBottom: { duration: 0.3, ease: 'easeInOut' },
                paddingTop: { duration: 0.3, ease: 'easeInOut' },
                paddingBottom: { duration: 0.3, ease: 'easeInOut' },
                borderColor: { duration: 0.3, ease: 'easeInOut' },
                borderWidth: { duration: 0.3, ease: 'easeInOut' },
            }}
            style={{
                borderStyle: 'solid',
                zIndex: isCompleting ? 10 : undefined,
                willChange: isCompleting ? 'transform, opacity' : 'auto',
            }}
            sx={{
                overflow: 'hidden',
                borderRadius: '12px',
                ...liquidGlassSurfaceFillSx,
            }}
        >
            {children}
        </Box>
    );
};
